export default "__VITE_ASSET__BFoVo4c5__"